import { componentsConfig as defaultConfig } from "srs.sharedcomponents/lib/esm/components/config";
import WelcomeBuilder from "srs.sharedcomponents/lib/esm/components/organisms/Welcome/BuilderContent/WelcomeBuilder"
import FooterBuilderComponent from "srs.sharedcomponents/lib/esm/components/organisms/Footer/FooterBuilder/FooterBuilder"
import CustomHeader from "srs.sharedcomponents/lib/esm/components/organisms/Header/Layout3";

const componentsConfig = { 
    ...defaultConfig, 
    Header: CustomHeader,
    WelcomeContent: WelcomeBuilder,
    FooterContent: FooterBuilderComponent,
};

export { componentsConfig };